import { ResourcesTab } from '../../components/organisms/navigation/ResourcesTab'
import useUserPermission from '../useUserPermission'

const usePaymentRoute = () => {
  const { canSeePaymentMethods } = useUserPermission('menu')

  return [{ path: '/medios-de-pago', component: ResourcesTab, hasPermission: canSeePaymentMethods }]
}
export default usePaymentRoute
